<template>
	<div class="health-check-container">
		<div class="section-selector-container">
			<div class="section-selector" :class="{'selected': this.currentSelectedSection === 'SERVER'}" @click="this.onSectionSelected('SERVER')">Server</div>
			<div class="section-selector" :class="{'selected': this.currentSelectedSection === 'NODE'}" @click="this.onSectionSelected('NODE')">Node</div>
		</div>
		<ServerInfoView v-if="this.currentSelectedSection === 'SERVER'"/>
		<NodeInfoView v-if="this.currentSelectedSection === 'NODE'"/>
	</div>
</template>

<script>

import {getRequestAsync, hideLoading, postRequestAsync, showLoading} from "@/utils/methods";
import ServerInfoView from "./ServerInfoView.vue";
import NodeInfoView from "./NodeInfoView.vue";

export default {
	name: "HealthCheckPage",
	components: {
		ServerInfoView,
		NodeInfoView
	},
	data() {
		return {

			currentSelectedSection: 'SERVER'
		}
	},
	async mounted() {
	},
	methods: {
		onSectionSelected (type) {
			this.currentSelectedSection = type
		}
	}
}
</script>

<style scoped>
.health-check-container {
	background-color: #191123;
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	padding: 0.4em;
	box-sizing: border-box;
	align-items: start;
	overflow-x: hidden;
	overflow-y: auto;
}

.section-selector-container{
	flex-direction: row;
	color: #FF8900;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
}

.section-selector{
	font-size: 1.2em;
	line-height: 1.2em;
	padding: 0.4em;
	cursor: pointer;
}

.selected {
	text-decoration: underline;
	font-weight: bold;
}
</style>